import { defineSlotRecipe } from '@chakra-ui/react';

export const tabsSlotRecipe = defineSlotRecipe({
	className: 'tabs',
	slots:     [ 'list', 'trigger', 'content' ],

	base: {
		content: { bg: 'white' },
		list:    { bg: 'gray.10' },

		trigger: {
			'&': {
				border:    0,
				padding:   '24px',
				textStyle: 'body',
			},
			'&:is([aria-selected=true], [data-selected])': {
				bg:          'white',
				borderColor: 'primary.100 !important',
				borderTop:   '4px solid',
				fontWeight:  'bold',
			},
		},
	},
});
